/* eslint-disable */
import { produce } from "immer";
import {
  CONTRIBUTION_CALCULATOR_POST_FETCH_FAILURE,
  CONTRIBUTION_CALCULATOR_POST_FETCH_SUCCESS,
  CONTRIBUTION_CALCULATOR_POST_FETCH_START,
} from "../actions/types";

const contributionCalcPost = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case CONTRIBUTION_CALCULATOR_POST_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CONTRIBUTION_CALCULATOR_POST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CONTRIBUTION_CALCULATOR_POST_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default contributionCalcPost;
